import { CheckoutType } from "../app/types/checkoutType";
import axios from "axios";

export const callApiSendOrder = async (checkout: CheckoutType) => {
  try {
    const response = await axios.post("/api/sendOrder", checkout);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Errore API sendOrder:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
        code: error.code
      });
      
      // Gestione errori specifici per status code
      if (error.response?.status === 420) {
        throw new Error("420 - Credito insufficiente");
      } else if (error.response?.status === 401) {
        throw new Error("401 - Sessione non autorizzata");
      } else if (error.response?.status === 403) {
        throw new Error("403 - Accesso negato");
      } else if (error.response?.status === 500) {
        throw new Error("500 - Errore interno del server");
      } else if (error.response?.status === 422) {
        throw new Error("422 - Dati di input non validi");
      } else if (error.code === "ERR_NETWORK") {
        throw new Error("ERR_NETWORK - Errore di connessione");
      } else if (error.code === "ERR_TIMEOUT") {
        throw new Error("ERR_TIMEOUT - Timeout della richiesta");
      } else {
        // Errore generico con status code
        throw new Error(`${error.response?.status || error.code} ${error.message}`);
      }
    } else {
      console.error('Errore generico sendOrder:', error);
      throw new Error("Errore sconosciuto durante l'invio dell'ordine");
    }
  }
};
